/* eslint-disable @typescript-eslint/no-explicit-any */
import { StateCreator } from 'zustand';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { createAppStore } from '@marriott/mi-store-utils';

type LegalGenericState = {
  locale: string;
  language: string;
  isAuthorMode: boolean;
  sessionData?: any;
};

type LegalGenericStateActions = {
  setLocale: (locale: string) => void;
  setLanguage: (language: string) => void;
  setIsAuthorMode: (isAuthorMode: boolean) => void;
  setSessionData: (sessionData: any) => void;
};

const initialState: LegalGenericState = {
  locale: '',
  language: '',
  isAuthorMode: true,
};

export const legalGenericStore: StateCreator<LegalGenericState & LegalGenericStateActions> = set => {
  return {
    ...initialState,

    setLocale: (locale: string) => {
      set(prevState => {
        return {
          ...prevState,
          locale,
        };
      });
    },
    setLanguage: (language: string) => {
      set(prevState => {
        return {
          ...prevState,
          language,
        };
      });
    },
    setIsAuthorMode(isAuthorMode: boolean) {
      set(prevState => {
        return {
          ...prevState,
          isAuthorMode,
        };
      });
    },
    setSessionData: (sessionData: any) =>
      set(prevState => ({
        ...prevState,
        sessionData,
      })),
  };
};

export const useLegalGenericStore = createAppStore(legalGenericStore);
